<pxd-grid [gridConfig]="gridConfig" [columns]="columns" [data]="data" [columnSettingsKey]="columnSettingsKey" [lockSelectionCheckbox]="false"></pxd-grid>